import React, { Component } from 'react';

import { Grid } from 'semantic-ui-react'

import withAuthorization from '../Session/withAuthorization';
import { db } from '../../firebase';

import { PhoneMap, SearchPhoneForm, PhoneList } from '../Phone'

class HomePage extends Component {

  state = {
    phones: undefined,
    phoneLocations: {}
  }

  componentDidMount() {
    db.onceGetPhones()
    .then(snapshot => {
      this.setState(() => ({
        phones: snapshot.val(),
      }))
    })
    .catch(error => {
      console.log(error);
    });
  }

  onPhoneLocationsFound = (phoneLocations, number) => {
    this.setState(() => ({
      phoneLocations,
      number
    }))
  }

  render() {
    const {
      phones,
      number,
      phoneLocations
    } = this.state;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={4} only="computer">
            <PhoneList
              phones={phones}
              number={number}
              onLocationsFound={this.onPhoneLocationsFound}
            />
          </Grid.Column>

          <Grid.Column mobile={16} computer={12} widescreen={12} largescreen={12}>
            <SearchPhoneForm
              onLocationsFound={this.onPhoneLocationsFound}
            />
            <PhoneMap
              locations={phoneLocations}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(HomePage);



// WEBPACK FOOTER //
// ./src/components/Home/index.js